module.exports = __webpack_public_path__ + "img/clicksLandingEpc.145ea032.svg";